import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useGlobalState } from '@/state'

const useQuery = () => {
  const history = useHistory()
  const [errorNotification, setErrorNotification] = useGlobalState('errorNotification')
  const csrfToken = (document.head.querySelector('[name~=csrf-token]') || {}).content

  const createQueryString = (data) => {
    let queryString = ''
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        queryString += `${key}=${data[key]}&`
      }
    })
    return queryString
  }


  const putpostRequest = (uri, method, data, fetchCallback) => {
    window.fetch(uri, {
      method: method,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': csrfToken,
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(data)
    }).then((response) => {
        console.log(response)
        if(response.status === 204) { // no content, specifically from stripe's payment method call
          fetchCallback(null, response)
          return
        }
        if(response.status >= 500) {
          setErrorNotification('There was an error. I am ashamed of myself and I will fix it as soon as I can.')
          fetchCallback('server error')
          return
        }
        response.json().then((data) => {
        if (response.status >= 200 && response.status < 400) {
            fetchCallback(null, data)
          } else if (response.status === 404) {
            history.replace(history.location.pathname, { errorStatusCode: 404 })
          } else if (response.status === 401) {
            setErrorNotification(data.errors || 'Unauthorized')
            fetchCallback({}) // want to make sure the promise is called
          } else if (response.status === 403) {
            // A 403 carrying `locked` or `joinable` is an offer, not a
            // failure: chat gates rooms and the caller renders the body as a
            // door. Pass the whole body and skip the global error toast.
            // Everything else keeps the old message-string contract.
            if (data && (data.locked || data.joinable)) {
              fetchCallback(data)
              return
            }
            setErrorNotification(data.errors || data.error || 'Forbidden')
            // Callback must fire, as it does for 401: a caller awaiting it
            // otherwise sits in its loading state forever. The course chat's
            // "not available" screen was unreachable for this reason.
            fetchCallback(data.errors || data.error || 'Forbidden')
          } else if (response.status === 422) {
            if (typeof data.errors !== 'string') { // object of errors handled by js components
              fetchCallback(data.errors || 'An error occured. Please try again')
            }
            if (typeof data.errors === 'string') { // custom error handled universally
              fetchCallback( data.errors || 'An error occured. Please try again')
            }
          } else {
            if (window.bugsnagClient) {
              window.bugsnagClient.notify(data.errors || 'An undefined error occured. No json')
            } else {
              console.log(data.errors)
            }
            fetchCallback(data.errors || 'An error occured. Please try again')
          }
        })
      })
      .catch((err) => {
        if (window.bugsnagClient) { window.bugsnagClient.notify(err) } else { console.log(err) }
        history.replace(history.location.pathname, { errorStatusCode: 504 })
      })
  }


  const getRequest = (uri, params, fetchCallback) => {
    const queryString = createQueryString(params)
    window.fetch(`${uri}?${queryString}`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': csrfToken,
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response) => {
      response.json().then((data) => {
        if (response.status >= 200 && response.status < 400) {
          fetchCallback(null, data)
        } else if (response.status === 404) {
          history.replace(history.location.pathname, { errorStatusCode: 404 })
        } else if (response.status === 401) {
          setErrorNotification(data.errors || 'Unauthorized')
          fetchCallback({}) // want to make sure the promise is called
        } else if (response.status === 422) {
          setErrorNotification(data.errors || "I can't do that right now.")
        } else if (response.status === 403) {
          // See the note in putpostRequest: a gated chat room answers 403
          // with an offer the caller renders, rather than an error.
          if (data && (data.locked || data.joinable)) {
            fetchCallback(data)
            return
          }
          setErrorNotification(data.errors || data.error || 'Forbidden')
          fetchCallback(data.errors || data.error || 'Forbidden')
        } else {
          if (window.bugsnagClient) { window.bugsnagClient.notify(data.errors) } else { console.log(data.errors) }
          fetchCallback(data.errors || 'An error occured. Please try again')
        }
      })
    }).catch((err) => {
      if (window.bugsnagClient) { window.bugsnagClient.notify(err) } else { console.log(err) }
      history.replace(history.location.pathname, { errorStatusCode: 504 })
    })
  }

  return {
    getRequest,
    createQueryString,
    putpostRequest
  }
}

export default useQuery
